import React, { useState } from 'react';
import './Filtros.css';

/**
 * Category tree. Presentational: the selected id and the whole filter list
 * are owned by the Productos container.
 */
const Categorias = ({ filtros, seleccionada, onSeleccionar }) => {
  const [abiertos, setAbiertos] = useState({});

  const alternar = (id) => {
    setAbiertos((previos) => ({ ...previos, [id]: !previos[id] }));
  };

  if (!filtros) {
    return (
      <div className="filtros-container">
        <h2>Categorías</h2>
        <div className="filtros-skeleton" aria-hidden="true">
          {Array.from({ length: 5 }, (_, i) => <span key={i} />)}
        </div>
      </div>
    );
  }

  const padres = filtros.filter((f) => f.idfiltropadre === null);

  return (
    <nav className="filtros-container" aria-label="Categorías">
      <h2>Categorías</h2>

      <button
        type="button"
        className={`filtro-todos ${seleccionada === null ? 'activo' : ''}`}
        onClick={() => onSeleccionar(null)}
      >
        Todas
      </button>

      {padres.map((padre) => {
        const hijos = filtros.filter((h) => h.idfiltropadre === padre.idfiltro);
        const abierto = !!abiertos[padre.idfiltro];

        return (
          <div className="filtro-grupo" key={padre.idfiltro}>
            <div className="filtro-padre-fila">
              <button
                type="button"
                className={`filtro-padre ${seleccionada === padre.idfiltro ? 'activo' : ''}`}
                onClick={() => onSeleccionar(padre.idfiltro)}
              >
                {padre.nombre}
              </button>

              {hijos.length > 0 && (
                <button
                  type="button"
                  className={`filtro-toggle ${abierto ? 'abierto' : ''}`}
                  onClick={() => alternar(padre.idfiltro)}
                  aria-expanded={abierto}
                  aria-label={`${abierto ? 'Contraer' : 'Desplegar'} ${padre.nombre}`}
                >
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="m6 9 6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              )}
            </div>

            {abierto && hijos.length > 0 && (
              <div className="hijos visible">
                {hijos.map((hijo) => (
                  <button
                    type="button"
                    key={hijo.idfiltro}
                    className={`filtro-hijo ${seleccionada === hijo.idfiltro ? 'activo' : ''}`}
                    onClick={() => onSeleccionar(hijo.idfiltro)}
                  >
                    {hijo.nombre}
                  </button>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default Categorias;
